module.exports = __webpack_public_path__ + "img/login-background2.98bd8072.jpg";